export default "__VITE_ASSET__373204fb__"